'use client';

import { useState } from 'react';

import { Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';

import { IntroQuizOnline } from '../components/intro-quiz-online';
import { StartQuizOnline } from '../components/start-quiz-online';
import { QuizOnlineDetailFunctions } from '../components/quiz-online-detail-functions';

export const QuizOnlineView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Container>
      <IntroQuizOnline setOpenDemoForm={(value) => setOpenDemo(value)} />
      <CustomerElearning />
      <QuizOnlineDetailFunctions />
      <StartQuizOnline setOpenDemoForm={(value) => setOpenDemo(value)} />
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Container>
  );
};
